enum UDExButtonSize {
  Large = "Large",
  Medium = "Medium",
  Small = "Small"
}

export default UDExButtonSize;
